'use client';

import * as React from 'react';

import { Calendar24Regular } from '@fluentui/react-icons';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import type { DateRange } from 'react-day-picker';

import { Popover, PopoverContent, PopoverTrigger } from '../../atoms/popover';
import { TextField } from '../../atoms/text-field';
import { Calendar } from '../calendar';

dayjs.extend(localizedFormat);

export type DateRangePickerProps = {
  onDateChange?: (date: DateRange | undefined) => void;
  value?: DateRange;
  placeholder?: string;
};

const getRangeValue = (date?: DateRange) => {
  if (!date) return '';

  return `${dayjs(date.from).format('L')} - ${dayjs(date.to).format('L')}`;
};

export const DateRangePicker = ({
  value,
  placeholder = 'Pick a date',
  onDateChange,
  ...props
}: DateRangePickerProps) => {
  const [date, setDate] = React.useState<DateRange | undefined>();
  const [inputValue, setInputValue] = React.useState<string>(() =>
    getRangeValue(value),
  );

  return (
    <Popover>
      <PopoverTrigger className="w-80">
        <TextField
          leftIcon={<Calendar24Regular className="text-gray-500" />}
          placeholder={placeholder}
          value={inputValue}
          {...props}
        />
      </PopoverTrigger>

      <PopoverContent className="w-100">
        <Calendar
          defaultMonth={date?.from}
          initialFocus
          mode="range"
          numberOfMonths={2}
          onSelect={(selectedDate) => {
            setDate(selectedDate);
            setInputValue(getRangeValue(selectedDate));
            onDateChange?.(selectedDate);
          }}
          selected={date}
        />
      </PopoverContent>
    </Popover>
  );
};
